export default "__VITE_ASSET__c0e4ed03__"